import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@material-ui/core';
import { useStyles } from './styles';
import { AppTable } from 'components/Tables/UserTable/appTable';

const AppDetail: FC = observer(() => {
  const classes = useStyles();
  return (
    <Container maxWidth='xl' className={classes.container}>
      <AppTable />
    </Container>
  );
});

export default AppDetail;
